import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/settings/integrations")({
  component: () => {
    return <Outlet />;
  },
  staticData: {
    getBreadcrumb({ pathname }) {
      const isExact = pathname === "/settings/integrations";
      return {
        href: "/settings/integrations",
        label: isExact ? undefined : "Integrations",
      };
    },
  },
});
